import React from 'react';
import Header from '../components/Header';
import "../sass/pages/_chartes.scss";

export default function Chartes() {
  return (
    <>
        <Header />
        <main className="chartes">
          <h2>La Charte Graphique en PDF</h2>
          <object data="/chartes_EH.pdf" width="100%" height="600px" type="application/pdf">
            <p>Votre navigateur ne prend pas en charge les fichiers PDF. Veuillez télécharger le fichier PDF pour le consulter : <a href="/chartes_EH.pdf">Télécharger le PDF.</a></p>
          </object>
        </main>
    </>
  )
}
